import {ActionHandler} from "../../../../../infrastructure/handlers/action-handler";
import {MatchEventsModuleState} from "../models/match-events-module.state";
import {MATCH_EVENTS} from "../match-events-widget.consts";

export class MatchEventModulePlayerClickHandler extends ActionHandler {
  state: MatchEventsModuleState;
  type = MATCH_EVENTS.ACTION_TYPES.onPlayerCardPopupClick;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    this.state.selectedAthleteId = params.selectedAthleteId;
    this.state.isPlayerCardPopupVisible = params.isVisible;
  }
}
